import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchSharedCalendars,
  type SharedCalendar,
} from './sharedCalendarsApi';

export function buildSharedCalendarsQueryKey(type: string) {
  return ['shared-calendars', type] as const;
}

export function useSharedCalendarsQuery({
  type = 'saved',
  enabled = true,
}: {
  type?: string;
  enabled?: boolean;
} = {}): UseQueryResult<SharedCalendar[], Error> {
  return useQuery({
    queryKey: buildSharedCalendarsQueryKey(type),
    queryFn: ({ signal }) => fetchSharedCalendars(type, signal),
    enabled,
    staleTime: 2 * 60_000,
    gcTime: 5 * 60_000,
    retry: false,
  });
}
